export default "__VITE_ASSET__Bq87HVn8__"